// @flow
import * as React from 'react';
import { memo } from 'react';
import { Box, Stack, SxProps, Typography } from '@mui/material';
import { Tooltip } from '@coverright/ui/inputs';

interface RecordProps {
  title: string,
  sx?: SxProps,
  value?: React.ReactNode | null,
  tooltip?: React.ReactNode | null,
  color?: 'default' | 'error',
}

export const Record = memo((props: RecordProps) => (
  <Stack gap={2} direction={'row'} alignItems={'center'} ml={1} sx={props.sx}>
    <Typography width={100} fontWeight={500} fontSize={12} className={'record-title'}
                color={props.color === 'error' ? 'error' : 'text.secondary'}>
      {props.title}
    </Typography>

    <Tooltip title={props.tooltip}>
      <Box flex={1} maxWidth={180} className={'record-value-wrapper'}>
        {typeof props.value === 'string' ? (
          <Typography fontWeight={500} className={'record-value'}
                      color={props.color === 'error' ? 'error' : 'text.primary'}
                      fontSize={14} noWrap overflow={'hidden'} textOverflow={'ellipsis'}>
            {props.value}
          </Typography>
        ) : props.value}
      </Box>
    </Tooltip>



  </Stack>
))
